<template>
    <div class="has-text-light scrollableY">
        <div v-if="!hasLoaded" id="spinnerTgt" class="top60"></div>
        <div v-show="doComplete">
           <div class="is-size-5 has-text-centered top40">Please Complete your Profile</div>
       </div>
        <div v-show="editMode" class="container top40 has-text-centered">

            <drop v-if="!cropper" class="has-text-centered posRelative is-inline-block"  @drop="dropOnCropper">
                <input type="file" style="display: none" @change="fileChanged"  ref="fileInput"/>
                  <div class="is-inline-block">
                    <img class="avatarLarge handCursor" :src="img" @click="fileChooser"/>
                </div>
            </drop>

            <div v-show="cropper" class="profileClipper">
                <clipper-basic  ref="clipper" :ratio="180/180"  :wrapRatio="180/180" :initWidth="95"  :src="imgEdit"> </clipper-basic>
           </div>
    
            <div class="is-inline-block vTop left10 has-text-left">

                <div class="is-pulled-right right10">
                    <button id="saveButt" class="button is-coolGreen" @click="save">SAVE</button>&nbsp;
                    <button class="button " @click="cancelEditMode">CANCEL</button>
                </div>
                
                <input type="text" class="input darkInput" style="width: 250px" v-model="handleEdit" placeholder="handle" /><br>
                <input type="text" class="input darkInput top5" style="width: 400px" v-model="taglineEdit" placeholder="tagline" />
         
                <textarea class="textarea darkInput top5" cols="83" v-model="bioEdit" placeholder="bio"></textarea>
            
            </div>
        </div>
       
       <div v-show="!notFound && loaded">
            
            <div v-show="!editMode" class="container top40 has-text-centered">
                <div class="searchProfiles">
                    <search-profiles class=" "></search-profiles>
                </div>
                <div class="is-inline-block top30">
                    <img v-show="img" class="avatarLarge" :src="img"/>
                    <div v-show="!img" class="avatarLarge"><i  class="fa fa-user top30 fa-4x"></i></div>
                </div>
        
                <div class="is-inline-block vTop left10 has-text-left profileHeader top30">
                    
                    <!-- <div v-show="!isOwn" class="is-pulled-right"><button class="button is-coolGreen is-small">follow</button></div> -->
                  <!--   <div v-show="isOwn" class="is-pulled-right">
                        <div class="miiscore">
                            <b>miiscore> 92</b>
                        </div>
                    </div> -->
                    <div class="is-size-3 is-inline-block"><b>{{handle}}</b></div>
                    <div v-if="isOwn" class="is-inline-block left8 vTop top10"><button class="button is-coolGreen is-small" @click="doEditMode"><i class="fa fa-pen"></i></button></div>
                    <div class="is-inline-block left8 vTop top10"><button class="button is-coolGreen is-small" @click="shareProfile($event)" v-tooltip="'share profile'"><i class="fa fa-share"></i></button></div>
                    <div class="is-size-5 left3 top-5"><b>{{tagline}}</b></div>
                    <div class="left3 profileBio">{{bio}}</div>
                </div>
            </div>

           
    
             <div class="has-background-coolGreen top20">
                 <div class="profileStats marginAutod has-text-dark">
                    <table width="100%" class="has-text-weight-semibold" style="margin-left: 28px">
                        <tr>
                            <td class="handCursor" @click="changeView('bundles')" :class="{selBG: currView == 'bundles'}">
                                {{bundles.length}}<br>
                                bundles
                            </td>
                            <td class="handCursor" @click="changeView('followers')" :class="{selBG: currView == 'followers'}">
                                {{numberFollowers}}<br>
                                followers
                            </td>
                            <td class="handCursor" @click="changeView('following')" :class="{selBG: currView == 'following'}">
                                {{numberFollowing}}<br>
                                following
                            </td>
                            <td>
                                {{numberMiimus}}<br>
                                miimus
                            </td>
                          <!--    <td>
                               <button class="button is-small"><b>My Links</b></button>
                            </td> -->
                        </tr>
                    </table>
                </div>
             </div>
    
            <br>
           <!--   <div class="container has-text-centered">
              
                    <bundle-thumbnail v-for="(item, i) in bundles" :key="i" :item="item"></bundle-thumbnail>
             </div> -->

            <!-- BUNDLES -->
            <div v-if="currView=='bundles'" class="container has-text-centered top20">
                 <div class="is-size-4"><b>Public Bundles</b></div>

                 <draggable class="top30" :draggable="editMode ? '.bundleThumbnailContainer' : 'a'" ghost-class="abc"  v-model="bundles" @start="drag=true" @end="drag=false" @update="onDrop">
                     <bundle-thumbnail ref="TN" class="bundleThumbnailContainer" v-for="(item) in bundles" :key="item.id" :item="item"></bundle-thumbnail>
                 </draggable>
            </div>

            <!-- FOLLOWERS -->
             <div v-if="currView=='followers'" class="container has-text-centered top20">
                 <div class="is-size-4"><b>Followers</b></div>

                <div class="has-text-left is-inline-block">
                     <div v-for="(item, ind) in followers" :key="ind" class="top20 handCursor" @click="$router.push({name: 'profiledelegate', params: {propProfile: item.handle}})">
                            <div class="avatarMed is-inline-block top2 left2">
                                <img :src="item.avatarImg" />
                            </div>
                            <div class="is-inline-block vTop is-size-4 top8 left3">
                                <b>{{item.handle}}</b>
                            </div>
                      </div>
                </div>
            </div>

            <!-- FOLLOWING -->
            <div v-if="currView=='following'" class="container has-text-centered top20">
                <div class="is-size-4"><b>Following</b></div>
                <div class="has-text-coolGreen handCursor" @click="toggleAll"><b>{{allOpen ? 'Hide' : 'Show'}} Followed Bundles</b></div>

                <span v-for="(item, ite) in following" :key="ite" >
                    <div v-if="ite == 0 || following[ite-1].handle != item.handle" class="top40 handCursor" >
                        <div class="is-inline-block" @click="$router.push({name: 'profiledelegate', params: {propProfile: item.handle}})">
                            <div class="avatarMed is-inline-block top2 left2">
                                <img :src="item.avatarImg" />
                            </div>
                            <div class="is-inline-block vTop is-size-4 top8 left3">
                                <b>{{item.handle}}</b>
                            </div>
                        </div>
                        <div v-if="!item.showBundles" class="is-inline-block vAlignTop top17 has-text-coolGreen left5 handCursor" @click="expandOne(item.handle)">
                            <i class="fas fa-caret-right"></i>
                        </div>

                        <div v-if="item.showBundles" class="is-inline-block vAlignTop top15 has-text-coolGreen left5 handCursor" @click="collapseOne(item.handle)">
                            <i class="fas fa-sort-down"></i>
                        </div>
                        
                    </div>
                    
                    <bundle-thumbnail v-if="item.showBundles" ref="TN" class="bundleThumbnailContainer" :item="item"></bundle-thumbnail>
                </span>
               
            </div>

           
       </div>

       <!-- <cms-section :id="40"></cms-section> -->

       <div v-show="notFound">
           <div class="is-size-5 has-text-centered top40">Profile not Found!</div>
       </div>
       <br/> <br/> <br/> <br/> <br/> <br/>

      
    </div>
</template>

<script>

import BundleThumbnail from '../components/BundleThumbnail.vue'
import SearchProfiles from '../components/SearchProfiles.vue'
import { AZEventBus } from '../components/AZEventBus'
import draggable from 'vuedraggable'
/* import CmsSection from './P.vue' */


export default {
    props: {
        propProfile: {
            type: String,
            default: ''
        },
        propMCode: {
            type: String,
            default: undefined
        },
        deep: {
            type: Number,
            default: null
        },
        currView: {
            type: String,
            default: 'bundles'
        },
        myBundle: {
            type: Boolean,
            default: false
        }
    },
    components: {BundleThumbnail, draggable, SearchProfiles},
    data: function(){
        return {
            inited: false,
            handle: '',
            tagline: '',
            bio: '',
            img: '',
            notFound: false,
            loaded: false,
            isOwn: false,
            doComplete: false,
            bundles: [],
            editMode: false,
            cropper: false,
            handleEdit: '',
            taglineEdit: '',
            bioEdit: '',
            imgEdit: '',
            imgChanged: false,
            hasLoaded: false,
            bundlesCopy: [],
            toUpdate: [],
            profId: null,
            following: [],
            followers: [],
            numberFollowers: 0,
            numberFollowing: 0,
            numberMiimus: 0,
            allOpen: false
        }
    },

    mounted: function(){

        var self = this;
        var profile

       

        window.onpopstate = function(event) {
         //alert("location: " + document.location + ", state: " + JSON.stringify(event.state));
          self.$root.app.closeModal()
        };

        if(self.propProfile){
            profile = self.propProfile
        } else if(self.$route.params.id){
            profile = self.$route.params.id;
        } else {
            profile = '!!';
        }

        function w(d){

            
            az.addRemSpinner(false, 'id', 'spinnerTgt')
            self.hasLoaded = true
           
            if(d == 'No Profile'){
                if(profile == '!!'){
                    self.editMode = true
                    self.doComplete = true
                    return
                } else {
                    self.notFound = true;
                    return
                }
            }

            self.handle = d.profile.handle || '';
            self.tagline = d.profile.tagline || '';
            self.bio = d.profile.bio || '';
            self.img = d.profile.avatarImg || ''
            self.isOwn = d.profile.isOwn;
            self.profId = d.profile.id

            self.numberFollowers = d.numberFollowers || 0
            self.numberFollowing = d.numberFollowing || 0
            self.numberMiimus = d.numberMiimus || 0

            d.publicBundles.forEach(e => {
                var arr = d.cards.filter(i => {
                    return i.id_BUNDLES == e.id_BUNDLES
                })
                if(arr[0] == undefined)
                    arr[0] = {img: 'asdfa'}
                if(arr[1] == undefined)
                    arr[1] = {img: 'asdfa'}
                if(arr[2] == undefined)
                    arr[2] = {img: 'asdfa'}

                var temp = {
                    id: e.id_BUNDLES,
                    descr: e.pubNote,
                    dateModified: e.dateModified,
                    listName: e.listName,
                    handle: e.handle,
                    avatarImg: e.avatarImg,
                    imgs: arr,
                    mCode: e.mCode,
                    p: e.p,
                    pubId: e.pubId,
                    fid: e.fid,
                    fState: e.fState,
                    lastUpdate: e.lastUpdate
                }
                self.bundles.push(temp)
            })

            self.bundles.sort((a,b) => {
                return a.p - b.p
            })

            self.bundlesCopy = self.bundles.slice()
      
            if(profile == '!!'){
                var temp = self.$route.path
                if(temp[temp.length - 1] != '/')
                    temp += '/'

                if(self.$route.fullPath == '/profile' || self.$route.fullPath == '/profile/'){
                    temp += d.profile.handle
                }

                history.replaceState(
                    {},
                    null,
                    temp
                )
            } else {
                

                self.$route.params.id = d.profile.handle
                
                var temp = self.$route.path
                if(temp[temp.length - 1] != '/')
                    temp += '/'
                    
                if(self.$route.fullPath == '/profile' || self.$route.fullPath == '/profile/')
                    temp += d.profile.handle
                else if(self.$route.fullPath.split('/b/').length == 1 && !self.$route.params.id)
                    temp += self.$route.params.id

                if(self.propMCode)
                    temp += '/b/' + self.propMCode;

                 history.replaceState(
                    {},
                    null,
                    temp
                )

                
            }
  
             self.loaded = true
            
             var theMCode = undefined
             if(self.propMCode){
                 self.$route.params.cat = 'b'
                 theMCode = self.propMCode;
             } else if (self.$route.params.mCode) {
                 theMCode = self.$route.params.mCode
             }

             if(self.$route.params.cat && theMCode){
                  self.$root.app.doShowModal('ModalBundle', {mCode: theMCode, deep: self.deep, myBundle: self.myBundle})     
             }
        }
        function n(){
            az.addRemSpinner(false, 'id', 'spinnerTgt')
        }

        function init(){
            if(self.propProfile){
                profile = self.propProfile
            } else if(self.$route.params.id){
                profile = self.$route.params.id;
            } else {
                profile = '!!';
            }

            az.addRemSpinner(true, 'id', 'spinnerTgt')
            self.inited = true;
            setTimeout(function(){
                if(self.$root.app.isAuth)
                    self.$root.app.apiClient.get('subs/data/profile/' + profile, {}, w, n)
                else
                    self.$root.app.apiClient.get('open/confirm/profile/' + profile, {}, w, n)
            },10)
            
        }

        if(self.$root.app.doneFederating){
            init();
        }

        AZEventBus.$once('onFederate', msg => {
        if(self.inited == false)
            init();
        });


    },

    methods: {
        changeView: function(v){
      
            this.currView = v;

           

            if(v == 'following')
                this.doFollowing()
            else if(v = 'followers')
                this.doFollowers()

              
        },

        shareProfile: function(e){
            e.preventDefault()
            this.$root.app.doShowModal('shareProfile', {profile: this.handle})
        },

        dropOnCropper: function(data, e){

            var self = this;


            e = e || window.event; // get window.event if e argument missing (in IE)
            if (e.preventDefault) {
                e.preventDefault();
            } // stops the browser from redirecting off to the image.



            var dt = e.dataTransfer;
            var files = dt.files;

            var fileReader = new FileReader();


            var file = files[0];

            if (/^image\/\w+$/.test(file.type)) {
                fileReader.readAsDataURL(file);
                fileReader.onload = function () {
                    self.img = this.result;
                    self.cropper = true;    
            
                };


            } else {
                showMessage("Please use an image file.");
            }


            return false;
            },

            doEditMode: function(){

                this.handleEdit = this.handle.slice();
                this.taglineEdit = this.tagline.slice();
                this.bioEdit = this.bio.slice();
                this.imgEdit = this.img.slice();

                this.bundlesCopy = this.bundles.slice()

                this.editMode = true

            },
            imgError: function(){
            this.img = this.defImg
    },
    fileChooser: function(){
        //this.imgSelected = true
        this.$refs.fileInput.click()
    },
    fileChanged: function(e){
        // getting a hold of the file reference

        var self = this;
        var file = e.target.files[0]; 

        
        // setting up the reader
        var reader = new FileReader();
        reader.readAsDataURL(file); // this is reading as data url

        // here we tell the reader what to do when it's done reading...
        reader.onload = readerEvent => {
            var content = readerEvent.target.result; // this is the content!
            if (/^image\/\w+$/.test(file.type)) {
            reader.readAsDataURL(file);
            reader.onload = function () {
                self.imgEdit = content;
                self.cropper = true;    
            };


            } else {
                this.$root.app.showModalOK({message: 'Please select an image file.'});
            }
            
            
            }
        },
        cancelEditMode: function(){
            this.cropper = false
            this.bundles = this.bundlesCopy.slice()
            this.editMode = false
        },
        cropperClip: function(){
            const canvas = this.$refs.clipper.clip();//call component's clip method
            this.resultURL = canvas.toDataURL("image/jpeg", 0.3);//canvas->image
            
            this.imgEdit = this.resultURL
            //this.img = this.imgEdit;
            this.imgChanged = true;
            this.cropper = false    
        },

        save: function(){
            var self = this;

            if(this.handleEdit.split(" ").length > 1){
                self.$root.app.showModalOK({message: 'Spaces are not allowed in handle.'})
                return
            }



            if(self.cropper){
                self.cropperClip()
            }
           
            function w(d){
                az.addRemSpinner(false, 'id', 'saveButt')

                if(d.r == 'handle taken'){
                    self.$root.app.showModalOK({message: 'Sorry, the handle you selected is already taken, please try a different one.'})
                    return
                }
                
                self.img = self.imgEdit
                self.handle = self.handleEdit.toLowerCase()
                self.tagline = self.taglineEdit
                self.bio = self.bioEdit
                self.editMode = false
                self.loaded = true

                self.bundlesCopy = self.bundles.slice()

            }
            function n(){
                 az.addRemSpinner(false, 'id', 'saveButt')
            }

            var changes = {}
            if(this.imgChanged)
                changes.imgFile = this.imgEdit
            else
                changes.imgFile = 'noChange'
            //if(this.handleEdit != this.handle)
                changes.handle = this.handleEdit.toLowerCase()
            //if(this.tagline != this.taglineEdit)
                changes.tagline = this.taglineEdit
            //if(this.bio != this.bioEdit)
                changes.bio = this.bioEdit

            az.addRemSpinner(true, 'id', 'saveButt')
            this.$root.app.apiClient.put('subs/data/profile', {changes: changes, toUpdate: this.toUpdate}, w, n)

        },
        closeAllMenus: function(){
            AZEventBus.$emit('closeAllMenus', null)
        },

        onDrop: function(ev){


            var newP

            //find p of newIndex
            let ind
            if(ev.newIndex == 0){
                //find p of index 1 and /2
                newP = this.bundles[1].p /2
            } else if(ev.newIndex == this.bundles.length - 1) {
                //find p of newIndex - 1 and *2
                newP = this.bundles[this.bundles.length-2].p *2
            } else {
                //find p of newIndex + 1, newIndex - 1 and half it
                let t1 = this.bundles[ev.newIndex + 1].p
                let t2 = this.bundles[ev.newIndex - 1].p
                newP = ((t1 - t2) / 2) + t2
            }

            this.bundles[ev.newIndex].p = newP


            //TODO calculate proximity effect
            
            //upsert all changes into list of updates
            var self = this
            let i = this.toUpdate.findIndex(e => {
                return e.pubId == self.bundles[ev.newIndex].pubId
            })

            if(i > -1){
                this.toUpdate[i].p = newP
            } else {
                this.toUpdate.push({p: newP, id: this.bundles[ev.newIndex].pubId})
            }
                      
        },

        updateTN: function(pubId, fid, fState){
 
            let b = this.bundles.find(e => {
                return e.pubId == pubId
            })

            if(fid != 'updated'){
                b.fid = fid
            }
            b.fState = fState
        },

        doFollowing: function(){

           
            this.allOpen = false
            var self = this;
            self.following.splice(0)
           

            function w(d){
                az.addRemSpinner(false, 'id', 'spinnerTgt')
                self.hasLoaded = true
            
                if(d == 'Handle does not exist'){
                   return
                }

              


                d.publicBundles.forEach(e => {
                    var arr = d.cards.filter(i => {
                        return i.id_BUNDLES == e.id_BUNDLES
                    })
                    if(arr[0] == undefined)
                        arr[0] = {img: 'asdfa'}
                    if(arr[1] == undefined)
                        arr[1] = {img: 'asdfa'}
                    if(arr[2] == undefined)
                        arr[2] = {img: 'asdfa'}

                    var temp = {
                        id: e.id_BUNDLES,
                        descr: e.pubNote,
                        dateModified: e.dateModified,
                        listName: e.listName,
                        handle: e.handle,
                        avatarImg: e.avatarImg,
                        imgs: arr,
                        mCode: e.mCode,
                        p: e.p,
                        pubId: e.pubId,
                        fid: e.fid,
                        fState: e.fState,
                        lastUpdate: e.lastUpdate,
                        showBundles: false
                    }
                    self.following.push(temp)
                })

                self.following.sort((a,b) => {
                    var nameA = a.handle.toUpperCase(); // ignore upper and lowercase
                    var nameB = b.handle.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                })

            }

            function n(){

            }

            this.$root.app.apiClient.get('subs/data/following/' + this.handle, {}, w, n)
        },

        doFollowers: function(){

          
            var self = this;
            self.followers.splice(0)

            function w(d){
              
                az.addRemSpinner(false, 'id', 'spinnerTgt')
                self.hasLoaded = true
            
                if(d == 'Handle does not exist'){
                   return
                }
           

                d.followers.forEach(e => {
                 

                    var temp = {
                       
                        handle: e.handle,
                        avatarImg: e.avatarImg,
                       
                    }
                    self.followers.push(temp)
                })

                self.followers.sort((a,b) => {
                    var nameA = a.handle.toUpperCase(); // ignore upper and lowercase
                    var nameB = b.handle.toUpperCase(); // ignore upper and lowercase
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    // names must be equal
                    return 0;
                })

            }

            function n(){

            }

            this.$root.app.apiClient.get('subs/data/followers/' + this.handle, {}, w, n)
        },

        expandOne: function(i){
            this.following.forEach(e => {
                if(e.handle == i)
                    e.showBundles = true
            })
        },

        collapseOne: function(i){
            this.following.forEach(e => {
                if(e.handle == i)
                    e.showBundles = false
            })
        },

        toggleAll: function(){
            var self = this;

              if(self.allOpen){
                self.allOpen = false
                this.following.forEach(e => {
                    e.showBundles = false
                })
              } else {
                self.allOpen = true
                this.following.forEach(e => {
                    e.showBundles = true
                })
              }

            
        }
     
    }

}
</script>

<style scoped>
    .abc {
        opacity: .5;
    }
    
</style>